import * as _ from 'lodash'
import axios from 'axios'
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export interface ITagDataRequest {
    RequestType: string,
    HierarchyId:number
}

export interface ITagLevel {
    NodeId: number,
    NodeLevel: string
}


export class PATagDataService {
    private processRequest(aRequest: ITagDataRequest): Promise<any[]> {
        const self = this
        return new Promise<any[]>((resolve, error) => {


            // Make the request while holding the lock
            self.makeBackEndRequest(aRequest)
                .then((res) => {
                    resolve(res)
                }).catch((err) => {
                error(err)
            })
        })


    }

    private makeBackEndRequest(aRequest: ITagDataRequest): Promise<any[]> {
        const self = this
        return new Promise<any[]>((resolve, reject) => {

            var sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/'))
                sEndPoint += 'tableautaghier';
            else
                sEndPoint += '/tableautaghier';

            axios.get(sEndPoint, {params:aRequest})
                .then((resp: any) => {
                    var responseData = resp.data;

                    if (_.isArray(responseData)) {
                        resolve(responseData);
                    } else {
                        reject('Unable to parse Tag Data Response: ' + responseData);
                    }
                })
                .catch((err: any) => {
                    reject('Unable to obtain Tag Data from Server. ' + err);
                });

        })
    }


    getNodeLevels(): Promise<ITagLevel[]> {
        const self = this
        return new Promise<ITagLevel[]>((resolve, error) => {
            self.processRequest({
                RequestType: 'getNodeLevels', HierarchyId:0
            }).then((results: any[]) => {
                resolve(results)
            }).catch((err) => {
                error(err)
            })

        })
    }


}